/** Texts of the settings pages (de), below `projects.settings`. */
export const settings = {
  title: 'Projektarten und Phasen',
  description:
    'Welche Arten von Projekten die Firma führt und welche Phasen ihre Leistungen haben.',
  current: 'Aktuell',
  archived: 'Archiviert',
  archiveFilter: 'Archiv',
  numberHint: 'Wie Projektnummern aussehen, steht im Nummernkreis.',
  numberLink: 'Zu den Einstellungen',
  empty: 'Noch keine Projektarten',
  emptyHint:
    'Die Standardvorlagen legen übliche Projektarten und Phasenvorlagen an. Danach lässt sich alles anpassen.',
  createDefaults: 'Standardvorlagen anlegen',
  defaultsCreated: 'Standardvorlagen angelegt.',
  noArchived: 'Nichts archiviert',
  actionsFor: 'Aktionen für {{name}}',
  archive: 'Archivieren',
  restore: 'Zurückholen',
  archivedToast: 'Archiviert.',
  restored: 'Zurückgeholt.',
  saved: 'Änderungen gespeichert.',
  types: {
    title: 'Projektarten',
    description: 'Die Art bestimmt, welche Abschnitte ein Projekt hat.',
    new: 'Neue Projektart',
    createTitle: 'Neue Projektart',
    editTitle: 'Projektart bearbeiten',
    created: 'Projektart angelegt.',
    name: 'Name',
    descriptionField: 'Beschreibung',
    sections: 'Abschnitte',
    object: 'Objekt',
    services: 'Leistungen',
    openEnded: 'laufend',
    usesObject: 'Objekt',
    usesObjectHint: 'Das Projekt bezieht sich auf ein Gebäude oder eine Liegenschaft.',
    usesServices: 'Leistungen und Phasen',
    usesServicesHint: 'Das Projekt hat Leistungen, z. B. Brandschutzkonzept, mit Phasen.',
    openEndedField: 'Laufender Auftrag',
    openEndedHint: 'Kein geplantes Ende, nur ein Vertragsende, z. B. Brandschutzbeauftragter.',
    defaultTemplate: 'Phasenvorlage',
    defaultTemplateHint: 'Vorschlag für neue Leistungen in Projekten dieser Art.',
    noTemplate: 'Keine',
    archivedTemplate: 'Archivierte Vorlage',
    sortOrder: 'Reihenfolge',
    sortOrderHint: 'Kleinere Zahlen stehen in Auswahlfeldern weiter oben.',
    empty: 'Noch keine Projektarten',
    emptyHint: 'Mit „Neue Projektart“ die erste Art anlegen.',
    archiveTitle: 'Projektart archivieren?',
    archiveDescription:
      '„{{name}}“ wird für neue Projekte nicht mehr angeboten. Bestehende Projekte behalten ihre Art.',
  },
  templates: {
    title: 'Phasenvorlagen',
    description:
      'Phasen, die eine neue Leistung übernimmt. Danach pflegt jedes Projekt sie selbst.',
    new: 'Neue Vorlage',
    createTitle: 'Neue Phasenvorlage',
    editTitle: 'Phasenvorlage bearbeiten',
    created: 'Phasenvorlage angelegt.',
    name: 'Name',
    nameHint: 'Z. B. „HOAI Objektplanung“ oder „AHO Brandschutz“.',
    phases: 'Phasen',
    phaseCount_one: '{{count}} Phase',
    phaseCount_other: '{{count}} Phasen',
    phasesHint: 'Kürzel ist freiwillig, z. B. LPH 1. Höchstens {{max}} Phasen.',
    codePlaceholder: 'Kürzel',
    phasePlaceholder: 'Name der Phase',
    codeOf: 'Kürzel der Phase {{position}}',
    nameOf: 'Name der Phase {{position}}',
    moveUp: 'Phase {{position}} nach oben',
    moveDown: 'Phase {{position}} nach unten',
    remove: 'Phase {{position}} entfernen',
    addPhase: 'Phase hinzufügen',
    empty: 'Noch keine Phasenvorlagen',
    emptyHint: 'Leistungen ohne Vorlage starten ohne Phasen.',
    archiveTitle: 'Phasenvorlage archivieren?',
    archiveDescription:
      '„{{name}}“ wird für neue Leistungen nicht mehr angeboten. Phasen in bestehenden Projekten bleiben, wie sie sind.',
  },
  errors: {
    name: 'Name eingeben.',
    phases: 'Jede Phase braucht einen Namen; erlaubt sind 1 bis 30 Phasen.',
    sortOrder: 'Ganze Zahl von 0 bis 9999 eingeben.',
    defaultTemplateId: 'Die gewählte Vorlage ist nicht mehr verfügbar.',
    invalid: 'Eingabe prüfen.',
    invalidInput: 'Eingaben prüfen.',
    versionConflict: 'Inzwischen von jemand anderem geändert. Dialog schließen und erneut öffnen.',
    notFound: 'Nicht gefunden. Vielleicht wurde der Eintrag archiviert.',
    forbidden: 'Dafür fehlt eine Berechtigung.',
  },
};
